<template>
  <svg
    version="1.1"
    id="レイヤー_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    :width="`${size}px`"
    :height="`${size}px`"
    viewBox="0 0 24 24"
    style="enable-background: new 0 0 24 24"
    xml:space="preserve"
  >
    <g id="グループ_626" transform="translate(26.649 11.273)">
      <g id="履歴アイコン" transform="translate(0 0)">
        <g id="グループ_682" transform="translate(0 0)">
          <path
            id="パス_102"
            :style="{
              fill: colors[0],
            }"
            d="M-5.1,2.9c0-0.3-0.1-0.6-0.3-0.6h-4.1c-0.2,0-0.3,0.3-0.3,0.6s0.1,0.6,0.3,0.6h4.1
				C-5.2,3.5-5.1,3.3-5.1,2.9z"
          />
          <path
            id="パス_103"
            :style="{
              fill: colors[0],
            }"
            d="M-4.8,0.2h-4.4c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h4.4c0.3,0,0.6-0.3,0.6-0.6
				C-4.2,0.4-4.5,0.2-4.8,0.2C-4.8,0.2-4.8,0.2-4.8,0.2z"
          />
          <path
            id="パス_105"
            :style="{
              fill: colors[0],
            }"
            d="M-5.1,5.1c0-0.3-0.1-0.6-0.3-0.6h-4.1c-0.2,0-0.3,0.3-0.3,0.6s0.1,0.6,0.3,0.6h4.1
				C-5.2,5.7-5.1,5.4-5.1,5.1z"
          />
          <path
            id="パス_106"
            :style="{
              fill: colors[0],
            }"
            d="M-5.1,7.3c0-0.3-0.1-0.6-0.3-0.6h-4.1c-0.2,0-0.3,0.3-0.3,0.6s0.1,0.6,0.3,0.6h4.1
				C-5.2,7.9-5.1,7.6-5.1,7.3z"
          />
          <path
            :style="{
              fill: colors[0],
            }"
            d="M-4.6-3.8h-6.8c-0.8,0-1.5,0.7-1.5,1.5V9.1c0,0.9,0.7,1.5,1.5,1.5h6.8c0.8,0,1.5-0.7,1.5-1.5V-2.3
				C-3.2-3.1-3.8-3.8-4.6-3.8z M-3.7,9.1c0,0.6-0.4,1-1,1h-6.8c-0.5,0-1-0.5-1-1V-2.3c0-0.6,0.4-1,1-1h6.8c0.5,0,1,0.5,1,1V9.1z"
          />
        </g>
      </g>
    </g>
    <g id="グループ_56">
      <path
        id="パス_45"
        :style="{
          fill: colors[0],
        }"
        d="M14.9,1.7H5l-5,8.6l5,8.6h9.9l5-8.6L14.9,1.7z"
      />
      <path
        id="パス_46"
        :style="{
          fill: colors[1],
        }"
        d="M4.2,9.2c0-0.1,0-0.2,0.1-0.3l0.3-0.4C4.6,8.4,4.8,8.4,5,8.5c0,0,0,0,0,0l2.5,2.2
		c0.1,0.1,0.2,0.1,0.3,0.1l0.7-0.1c0.1,0,0.1,0,0.2-0.1l1.2-1.5c0-0.1,0.1-0.1,0.1-0.2l0-0.7c0-0.1,0-0.1-0.1-0.2L7.4,5.9
		c-0.1-0.1-0.1-0.3,0-0.4L7.7,5c0.1-0.1,0.2-0.1,0.3-0.1c1.4,0,3.8,0.8,4.7,2.4c0.5,0.8,0.8,1.6,0.8,2.6c0.1,0.7,0.5,1.4,1,1.9
		L18,14l-1.8,3.1l-3.7-2.7c-1.4-0.8-3.5,0.8-5.7-0.6C4.7,12.6,4.1,10.8,4.2,9.2z"
      />
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'maintenanceHistory',
    props: {
      size: {
        type: Number,
        default: 20,
      },
      colors: {
        type: Array,
        default: () => ['#6F6F6F', '#FFFFFF'],
      },
    },
  };
</script>
